// extracted by mini-css-extract-plugin
export var component = "NoticeModule-module--component--hcMKD";
export var content = "NoticeModule-module--content--I+aON";
export var hasIcon = "NoticeModule-module--hasIcon--0gf7X";
export var icon = "NoticeModule-module--icon--TBH1w";